import React from 'react';
import { graphql, compose } from 'react-apollo';
import { Redirect } from 'react-router-dom';
import Spinner from '../../spinner/spinner';
import { Button, Form, Row, Col } from 'antd';
import CreateEvangelistForm from './createEvangelistForm';
import { getEvangelist } from "./queries/getEvangelist";
import { updateEvangelist } from "./mutations/updateEvangelist";

const onCancelClick = (history) => { history.push("/dashboard/admin/evangelists/") };

class EditEvangelistPage extends React.Component {
  mutationParams = () => {
    return {
      variables: {
        input: {
          ...this.props.form.getFieldsValue(),
          id: parseInt(this.evangelist.id)
        }
      }
    }
  };

  redirectTo = (data) => {
    this.props.history.push(`/dashboard/admin/evangelists`);
  };

  get evangelist() {
    return this.props.data.evangelist;
  }

  formControls(loading) {
    return (
      <Row type="flex" justify="end" className="align-right">
        <Col xs={{ span: 24, order: 1 }} md={{ span: 6, order: 0 }}>
          <Button onClick={() => { onCancelClick(this.props.history) }} className="evangelists-list__control">
            Cancel Updates
          </Button>
        </Col>
        <Col xs={{ span: 24, order: 0 }} md={{ span: 6, offset: 1, order: 1 }}>
          <Button type="primary" htmlType="submit" className="evangelists-list__control" loading={loading}>
            Save Updates
          </Button>
        </Col>
      </Row>
    );
  }

  render() {
    if (this.props.data.loading) {
      return (
        <Spinner/>
      );
    } else if (this.evangelist) {
      return (
        <CreateEvangelistForm {...this.props } evangelist={this.evangelist}
                             formControls={this.formControls.bind(this)}
                             mutationParams={this.mutationParams}
                             redirectTo={this.redirectTo}
                             onSubmit={this.onSubmit}/>
      );
    } else {
      return <Redirect to="/404" />;
    }
  }
}

export default Form.create()(
  compose(
    graphql(getEvangelist, {
      options: ({ match }) => ({
        variables: { evangelistId: parseInt(match.params.evangelistId, 10) },
        fetchPolicy: 'cache-and-network'
      })
    }),
    graphql(updateEvangelist)
  )(EditEvangelistPage)
);



// WEBPACK FOOTER //
// ./src/components/pages/evangelists/evangelistEdit.js